'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserQuote = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CmsCta = require('components/CmsPage/modules/CmsCta');

var _multitrack = require('helpers/multitrack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserQuote = exports.UserQuote = function (_Component) {
  (0, _inherits3.default)(UserQuote, _Component);

  function UserQuote(props) {
    (0, _classCallCheck3.default)(this, UserQuote);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserQuote.__proto__ || (0, _getPrototypeOf2.default)(UserQuote)).call(this, props));

    _this.handleCtaClick = _this.handleCtaClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserQuote, [{
    key: 'handleCtaClick',
    value: function handleCtaClick() {
      (0, _multitrack.ga)('User Quote Module', 'Clicked CTA');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          author = _props.author,
          copy = _props.copy,
          cta = _props.cta,
          desktopImage = _props.desktopImage,
          location = _props.location,
          mediaQuerySm = _props.mediaQuerySm,
          mobileImage = _props.mobileImage,
          theme = _props.theme,
          title = _props.title;


      return _react2.default.createElement(
        'div',
        { className: 'user-quote' },
        _react2.default.createElement('div', {
          className: 'user-quote__placeholder',
          style: { backgroundImage: 'url(' + (mediaQuerySm ? desktopImage : mobileImage) + ')' }
        }),
        _react2.default.createElement(
          'div',
          { className: 'user-quote__content user-quote__content--' + theme },
          _react2.default.createElement(
            'blockquote',
            { className: 'user-quote__content__text' },
            _react2.default.createElement(
              'h2',
              null,
              title
            ),
            _react2.default.createElement(
              'p',
              { className: 'text--lg' },
              copy
            ),
            _react2.default.createElement(
              'footer',
              null,
              _react2.default.createElement(
                'cite',
                { className: 'text--md text--bold' },
                author
              ),
              _react2.default.createElement(
                'p',
                { className: 'text--xs' },
                location
              )
            )
          ),
          cta && _react2.default.createElement(
            'div',
            { className: 'user-quote__content__cta' },
            _react2.default.createElement(_CmsCta.CmsCta, (0, _extends3.default)({}, cta, { onClick: this.handleCtaClick }))
          )
        )
      );
    }
  }]);
  return UserQuote;
}(_react.Component);

UserQuote.propTypes = {
  author: _propTypes2.default.string,
  copy: _propTypes2.default.string,
  cta: _propTypes2.default.object,
  desktopImage: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.string,
  mediaQuerySm: _propTypes2.default.bool,
  mobileImage: _propTypes2.default.string.isRequired,
  theme: _propTypes2.default.oneOf(['dark', 'light']).isRequired,
  title: _propTypes2.default.string.isRequired
};